import * as React from "react"
import { useSignal } from "@preact/signals-react"
import { Grid, Typography } from "@mui/material"
import { TabsSeeker } from "@ui-seeker/core"
import { formatDate } from "@ui-seeker/utils"

import { HierarchicalTextBlock, ImageSkuBlock, LabelCountry, SkuLinkLabel } from "@components"
import {
    AdminScrapingDataReviewDetailsDrawerContentTabDescription, AdminScrapingDataReviewDetailsDrawerContentTabFeatures, AdminScrapingDataReviewDetailsDrawerContentTabInternalInfo
} from "./Tabs"
import { ActualListBlock } from "../@components"
import { useAdminScrapingDataReviewDetails } from "../@hooks"
import { adminScrapingDataReviewDetails } from "../@signals"


export default function AdminScrapingDataReviewDetailsDrawerContent() {
	const displayInfoID = useSignal(0)

	// El texto de la ficha y las galerías llegan de `/show-details` al abrir el drawer, no dentro
	// de cada fila de la tabla. Se mezclan encima de la fila: lo que trae el detalle manda.
	const { detailsData } = useAdminScrapingDataReviewDetails()

	const {
        brandRaw, country, retailer, date, thumbnail, productName, ean, productUrl, actualPrice, listPrice, currency, ...extraData
    } = { ...adminScrapingDataReviewDetails.value, ...detailsData }

	return <Grid container spacing={2}>
		<Grid item xs={12} sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
			<Typography variant="h5">
                {brandRaw}
            </Typography>
			<LabelCountry country={country} label={retailer} />
			<Typography>
                { !!date && formatDate(new Date(date)) }
            </Typography>
		</Grid>

		<Grid item xs={12}>
			<ImageSkuBlock
				hideName
				imageURL={thumbnail}
				name={productName}
				height={300}
				isClickable={false}
			/>
		</Grid>

		<Grid item xs={12}>
			<SkuLinkLabel url={productUrl} skuName={productName} variant="h5" maxWidth={400} />
			<HierarchicalTextBlock title="EAN: " titleValue={ean || "--"} />
		</Grid>

		<Grid item xs={12}>
			<ActualListBlock 
                actualPrice={actualPrice} 
                listPrice={listPrice} 
                currency={currency} 
                variant="subtitle1"
            />
		</Grid>

		<Grid item xs={12}>
			<TabsSeeker
				showTabID={displayInfoID.value}
				onChange={(_, newValue) => displayInfoID.value = newValue}
				tabs={[
					{ label: "Features", value: 0 },
					{ label: "Description", value: 1 },
					{ label: "Internal info", value: 2 },
				]}
			/>
		</Grid>

		<Grid item xs={12}>
			{ displayInfoID.value === 0 && <AdminScrapingDataReviewDetailsDrawerContentTabFeatures {...extraData} currency={currency} /> }
			{ displayInfoID.value === 1 && <AdminScrapingDataReviewDetailsDrawerContentTabDescription {...extraData} /> }
			{ displayInfoID.value === 2 && <AdminScrapingDataReviewDetailsDrawerContentTabInternalInfo {...extraData} /> }
		</Grid>
	</Grid>
}